import enumMapper from "./enumMapper";

const DictionayToList = (dict) => {
   const arr = Object.keys(dict).map((key) => ({
      key: key,
      value: dict[key],
   }));
   return arr;
}

const RoomTypeBorderColor = (roomdto) => {
   return `${roomdto?.roomType === enumMapper.RoomType.Themanagerandclergyofthecaravans ? "blueBorder" :
      roomdto?.roomType === enumMapper.RoomType.Managers ? "dashedRedBorder" :
         roomdto?.roomType === enumMapper.RoomType.DeputyManagers ? "darkRedBorder" :
            roomdto?.roomType === enumMapper.RoomType.clergy ? "dashedGreenBorder" :
               roomdto?.roomType === enumMapper.RoomType.clergyOfTwoPlans ? "darkGreenBorder" :
                  roomdto?.roomType === enumMapper.RoomType.HousingAvailable ? "" : "blackBorder"
      }`
}

const helper = { DictionayToList, RoomTypeBorderColor }



export default helper;